import { render, staticRenderFns } from "./UserLink.vue?vue&type=template&id=d9796cf0&scoped=true&"
import script from "./UserLink.vue?vue&type=script&lang=js&"
export * from "./UserLink.vue?vue&type=script&lang=js&"
import style0 from "./UserLink.vue?vue&type=style&index=0&id=d9796cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9796cf0",
  null
  
)

export default component.exports